import { Injectable } from "@angular/core";
import { Observable, defer } from "rxjs";
import { environment } from "../../../environments/environment";

interface LazyStorage {
  sdk: typeof import("@angular/fire/storage");
  storage: import("@angular/fire/storage").FirebaseStorage;
}

let storagePromise: Promise<LazyStorage> | null = null;

// Shared by uploads and downloads; a failed chunk load can be retried on the next request.
export function loadFirebaseStorage(): Promise<LazyStorage> {
  return (storagePromise ??= Promise.all([import("@angular/fire/app"), import("@angular/fire/storage")])
    .then(([app, sdk]) => ({
      sdk,
      storage: sdk.getStorage(
        app.getApps().find(instance => instance.name === "[DEFAULT]") ?? app.initializeApp(environment.firebaseConfig),
      ),
    }))
    .catch((error: unknown) => {
      storagePromise = null;
      throw error;
    }));
}

@Injectable({ providedIn: "root" })
export class FirebaseStorageService {
  // Download URL of any file in Firebase Storage (tutorial videos and their posters)
  public getDownloadUrl(path: string): Observable<string> {
    return defer(async () => {
      const { sdk, storage } = await loadFirebaseStorage();
      return sdk.getDownloadURL(sdk.ref(storage, path));
    });
  }
}
